export enum EnvApplicationNames {
	Akina = "Akina",
	Relias = "Holliblu",
	Bitcoin = "BitcoinApp"
}
